export default __webpack_public_path__ + "static/eurad-logo-h100px-gray-36203dcb4284bcb3a552f14b003248d8.png";